import { Box } from '@mui/material'
import { CircleAlert, CircleCheck, CircleDashed, Clock } from 'lucide-react'
import { tokens } from '@agribot/polygon-checks-ui'
import { STATUS_LABEL } from '../rules'
import type { SubmissionStatus } from '../types'

const TONE: Record<SubmissionStatus, { bg: string; fg: string; Icon: typeof Clock }> = {
  draft: { bg: tokens.color.ink100, fg: tokens.color.ink600, Icon: CircleDashed },
  submitted: { bg: tokens.color.brandTeal100, fg: '#18576e', Icon: Clock },
  validation_in_progress: { bg: tokens.color.brandTeal100, fg: '#18576e', Icon: Clock },
  validated: { bg: tokens.color.brandTeal100, fg: '#18576e', Icon: Clock },
  in_final_review: { bg: tokens.color.brandTeal100, fg: '#18576e', Icon: Clock },
  approved: { bg: tokens.color.brandGreen100, fg: '#1f4741', Icon: CircleCheck },
  returned: { bg: tokens.color.tintWarning, fg: '#7d5a1a', Icon: CircleAlert },
}

/** A submission's status in the campaign's words, with an icon: never colour alone. */
export function StatusPill({ status }: { status: SubmissionStatus }) {
  const { bg, fg, Icon } = TONE[status]
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: 1, height: 22, px: 2,
        borderRadius: `${tokens.radius.pill}px`, backgroundColor: bg, color: fg,
        font: `500 12px ${tokens.font.sans}`, whiteSpace: 'nowrap',
      }}
    >
      <Icon size={13} strokeWidth={2} />
      {STATUS_LABEL[status]}
    </Box>
  )
}
